import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

interface IGetAllRoleListRequest {
  status?:string
}

type IGetAllRoleListResponse = BaseResponse<any>;

async function getAllRoleList(status?:string): Promise<IGetAllRoleListResponse> {
  try {
    return (await axiosInstance.get("/Role/All",{params:{status}})).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetAllRoleList(status?:string) {
  return useQuery<any | undefined, Error>([QueryKeys.GetAllRoleList,status], () =>
    getAllRoleList(status)
  );
}
